/**
 * Gallery Popup Component
 * Opens fullscreen gallery popup and scrolls to selected item
 */
;(function () {
  'use strict'

  const SELECTORS = {
    galleryItem: '[data-gallery-item]',
    dialog: '#gallery-popup',
    dialogSlider: '.rd-gallery-popup__slider',
    dialogItems: '.rd-gallery-popup__slider [data-gallery-item]',
    closeButton: '.rd-gallery-popup__close',
  }

  let dialog = null
  let dialogSlider = null
  let currentVideoIframe = null

  /**
   * Stop all videos in popup
   */
  function stopAllVideos() {
    if (!dialog) return

    const iframes = dialog.querySelectorAll('iframe')
    iframes.forEach((iframe) => {
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        )
      } catch (e) {
        // Ignore errors
      }
    })

    currentVideoIframe = null
  }

  /**
   * Play video in current iframe
   */
  function playCurrentVideo(iframe) {
    if (!iframe || iframe.tagName !== 'IFRAME') return

    currentVideoIframe = iframe

    setTimeout(() => {
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        )
      } catch (e) {
        // Ignore errors
      }
    }, 300)
  }

  /**
   * Open popup and scroll to item
   */
  function openGalleryPopup(itemIndex) {
    if (!dialog) return

    dialog.showModal()

    setTimeout(() => {
      const dialogItems = dialogSlider.querySelectorAll(SELECTORS.dialogItems)
      if (dialogItems[itemIndex]) {
        dialogItems[itemIndex].scrollIntoView({
          behavior: 'instant',
          block: 'nearest',
          inline: 'center',
        })

        const targetItem = dialogItems[itemIndex]
        if (targetItem && targetItem.tagName === 'IFRAME') {
          playCurrentVideo(targetItem)
        }
      }
    }, 50)

    const closeBtn = dialog.querySelector(SELECTORS.closeButton)
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 100)
    }
  }

  /**
   * Close popup
   */
  function closeGalleryPopup() {
    if (!dialog) return

    stopAllVideos()
    dialog.close()

    if (dialogSlider) {
      dialogSlider.scrollLeft = 0
    }
  }

  /**
   * Handle gallery item click
   */
  function handleGalleryItemClick(event) {
    event.preventDefault()

    const clickedItem = event.currentTarget
    const galleryId = clickedItem.getAttribute('data-gallery-item')

    const allItems = Array.from(
      document.querySelectorAll(`[data-gallery-item="${galleryId}"]`)
    ).filter((item) => !item.closest('#gallery-popup'))

    let itemIndex = 0
    for (let i = 0; i < allItems.length; i++) {
      if (allItems[i] === clickedItem) {
        itemIndex = i
        break
      }
    }

    openGalleryPopup(itemIndex)
  }

  /**
   * Get current visible item in slider
   */
  function getCurrentVisibleItem() {
    if (!dialogSlider) return null

    const dialogItems = dialogSlider.querySelectorAll(SELECTORS.dialogItems)
    const sliderRect = dialogSlider.getBoundingClientRect()
    const sliderCenter = sliderRect.left + sliderRect.width / 2

    let closestItem = null
    let minDistance = Infinity

    dialogItems.forEach((item) => {
      const itemRect = item.getBoundingClientRect()
      const itemCenter = itemRect.left + itemRect.width / 2
      const distance = Math.abs(itemCenter - sliderCenter)

      if (distance < minDistance) {
        minDistance = distance
        closestItem = item
      }
    })

    return closestItem
  }

  /**
   * Handle slider scroll - stop/play video
   */
  function handleSliderScroll() {
    if (currentVideoIframe) {
      stopAllVideos()
    }

    clearTimeout(dialogSlider.scrollEndTimeout)
    dialogSlider.scrollEndTimeout = setTimeout(() => {
      const visibleItem = getCurrentVisibleItem()

      if (visibleItem && visibleItem.tagName === 'IFRAME') {
        playCurrentVideo(visibleItem)
      }
    }, 300)
  }

  /**
   * Initialize
   */
  function init() {
    dialog = document.querySelector(SELECTORS.dialog)
    if (!dialog) return

    dialogSlider = dialog.querySelector(SELECTORS.dialogSlider)
    if (!dialogSlider) return

    const galleryItems = document.querySelectorAll(SELECTORS.galleryItem)

    galleryItems.forEach((item) => {
      if (!item.closest('#gallery-popup')) {
        item.style.cursor = 'pointer'
        item.addEventListener('click', handleGalleryItemClick)
      }
    })

    const closeBtn = dialog.querySelector(SELECTORS.closeButton)
    if (closeBtn) {
      closeBtn.addEventListener('click', closeGalleryPopup)
    }

    if (dialogSlider) {
      dialogSlider.addEventListener('scroll', handleSliderScroll)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
